// extracted by mini-css-extract-plugin
export default {"backdrop":"Loading_backdrop__0qZ1n","main":"Loading_main__3NWHx","loader":"Loading_loader__4C8Bo","spinner":"Loading_spinner__kL5CV"};